import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	margin-bottom: 2rem;
`;

export const LegendWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
`;
